import React from "react";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";

const RefundPolicy = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        <div className="static-header">
          <h1 className="container">Cancellation and Refund Policy</h1>
        </div>
        <div className="container mt-3">
          <p className="mb-4">
            At UpskillMeet, we understand that schedules can change. To ensure
            fairness and maintain the integrity of our community, we’ve outlined
            the following cancellation and refund guidelines for both Explorers
            (learners) and Experts (mentors):
          </p>
          <hr />
        </div>
        <div className="container">
          <h5 className="mb-3">
            <b>For Explorers (Learners)</b>
          </h5>
          <p className="mb-3">
            <b>Cancelling a Paid Session</b>
          </p>
          <ul>
            <li>
              Cancel up to 24 hours before the session start time: <br />
              Full refund issued automatically to your original payment method.
            </li>
            <li>
              Cancel within 24 hours of the session start time: <br />
              No refund will be issued, except in exceptional circumstances (see
              below).
            </li>
            <li>
              No Shows: <br /> Missed sessions without prior cancellation are
              not eligible for a refund.
            </li>
          </ul>
        </div>
        <div className="container mt-3">
          <p className="mb-3">
            <b>Exceptional Cases</b>
          </p>
          <p>
            If you missed the session due to medical emergencies, technical
            issues, or other valid concerns:
          </p>
          <ul>
            <li>
              Contact us within 48 hours of the scheduled session at{" "}
              <a href="mailto:support@upskillmeet.com">
                support@upskillmeet.com
              </a>{" "}
              with appropriate proof
            </li>
            <li>
              Refund or rescheduling will be reviewed on a case-by-case basis
            </li>
          </ul>
          <hr />
        </div>

        <div className="container mt-3">
          <h5>
            <b>For Experts (Mentors)</b>
          </h5>
          <p>
            <b>Cancelling a Session</b>
          </p>
          <ul>
            <li>
              Experts must cancel or request a reschedule at least 24 hours in
              advance
            </li>
            <li>
              Repeated cancellations or short-notice reschedules may impact your
              visibility or account standing
            </li>
          </ul>
          <p>
            <b>No-shows or Last-Minute Cancellations by Experts</b>
          </p>
          <ul>
            <li>
              If an expert cancels within 24 hours or doesn’t show up:
              <br /> A full refund will be issued to the Explorer.
              <br />
              The session will not be counted towards payout.
            </li>
          </ul>
          <hr />
        </div>

        <div className="container mt-3">
          <h5>
            <b>RESCHEDULING POLICY</b>
          </h5>
          <ul>
            <li>
              <b>Explorer-initiated rescheduling:</b>
              <ul>
                <li>Must be done at least 24 hours in advance.</li>
                <li>Subject to expert availability</li>
              </ul>
            </li>
            <li>
              <b>Expert-initiated rescheduling</b>
              <ul>
                <li>Must be approved by the Explorer</li>
                <li>
                  If the Explorer does not accept the reschedule request, the
                  session will proceed as originally scheduled
                </li>
                <li>
                  If the Explorer does not attend the session and marks the
                  mentor as a no-show, it will not affect the mentor, as the
                  mentor had initiated a reschedule request and the Explorer did
                  not respond
                </li>
              </ul>
            </li>
          </ul>
          <hr />
        </div>

        <div className="container mt-3">
          <h5>
            <b>FREE SESSIONS</b>
          </h5>
          <ul>
            <li>
              Free sessions can be cancelled or rescheduled up to 1 hour in
              advance
            </li>
            <li>
              No refunds apply, but multiple no-shows may result in account
              warnings.
            </li>
          </ul>
          <hr />
        </div>

        <div className="container mt-3">
          <h5>
            <b>REFUND PROCESS</b>
          </h5>
          <ul>
            <li>
              Approved refunds will be processed within 5 - 7 business days
            </li>
            <li>Refunds will be issued to the original payment method only</li>
          </ul>
          <hr />
        </div>

        <div className="container mt-3">
          <p>
            For any cancellation, refund, or rescheduling concerns, please
            contact{" "}
            <a href="mailto:support@upskillmeet.com">support@upskillmeet.com</a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundPolicy;
